/*jshint esversion: 6 */
import createUAParser from 'ua-parser-js'

export default class UAParser {
  constructor() {
    if (typeof navigator === 'undefined') {
      return {}
    }
    const ua = createUAParser()
    const UA_LOWERCASE = navigator.userAgent.toLowerCase(),
      OS_NAME = ua.os.name,
      BROWSER_NAME = ua.browser.name,
      DEVICE_MODEL = ua.device.model,
      isAndroid = OS_NAME === 'Android',
      isIOS = OS_NAME === 'iOS',
      isWindowsPhone = OS_NAME === 'Windows Phone',
      // Excludes android tablets by checking for one dimension smaller than 600px
      isAndroidPhone = isAndroid && (window.innerWidth < 600 || window.innerHeight < 600),
      isIPhone = DEVICE_MODEL === 'iPhone',
      isIPad = DEVICE_MODEL === 'iPad',
      isIPod = DEVICE_MODEL === 'iPod',
      isFirefox = BROWSER_NAME === 'Firefox',
      isSafari = BROWSER_NAME === 'Safari' || BROWSER_NAME === 'Mobile Safari',
      isChrome = BROWSER_NAME === 'Chrome',
      isChromeIOS = isChrome && isIOS,
      // IE 11 identifies itself as everything but MSIE
      // trident is the only distinct value in the UA String
      // however, the version number of trident is meaninless && will
      // break our version detection, so we identify it separately
      isMSIE11 = !!UA_LOWERCASE.match(/trident/i),
      isMSIE = !!UA_LOWERCASE.match(/msie/i),
      isEdgeBrowser = !!UA_LOWERCASE.match(/edge/i)

    const atLeastVersion = function (required) {
      var version = ua.browser.version
      return version && required && parseFloat(required) <= parseFloat(version)
    }

    const atLeastOSVersion = function (required) {
      var version = ua.os.version
      return version && required && parseFloat(required) <= parseFloat(version)
    }

    const nativeAppSupported = function () {
      return (isIPhone && atLeastOSVersion(9)) || (isAndroidPhone && atLeastOSVersion(4.4))
    }

    return {
      userAgent: navigator.userAgent,
      isIOS: isIOS,
      isIPod: isIPod,
      isIPad: isIPad,
      isIPhone: isIPhone,

      isAndroid: isAndroid,
      isAndroidPhone: isAndroidPhone,
      isFirefox: isFirefox,
      isSafari: isSafari,
      isChome: isChrome,
      isChomeIOS: isChromeIOS,

      isMSIE: isMSIE,
      isMSIE11: isMSIE11,
      isEdgeBrowser: isEdgeBrowser,
      isWindowsPhone: isWindowsPhone,

      browser: ua.browser,
      device: ua.device,
      os: ua.os,
      atLeastVersion: this.atLeastVersion,
      atLeastOSVersion: this.atLeastOSVersion,
      supportsPushState: window.history && window.history.pushState,
      isUnsupportedBrowser: isMSIE && !atLeastVersion(10),

      hasTouch: !!('ontouchstart' in window) || navigator.msMaxTouchPoints,
      devicePixelRatio: window.devicePixelRatio || 1,
      nativeAppSupported: nativeAppSupported(),
      atLeastVersion: atLeastVersion,
      atLeastOSVersion: atLeastOSVersion
    }
  }
}
